export const FETCH_TRAINER = 'FETCH_TRAINER';
export const PATCH_TRAINER = 'PATCH_TRAINER';
export const WECHAT_UNBIND = 'WECHAT_UNBIND';



// WEBPACK FOOTER //
// ./src/store/trainer/types.js